module.exports = __webpack_public_path__ + "static/ski-rent-782c1bcfc25633ce6bf0a091281b842a.svg";